<template>
  <client-only>
    <div class="countryCode-requestLocation hidden">
      {{ requestLocation.countryCode?.toUpperCase() }}
    </div>
  </client-only>

  <!-- Because the maximum variant is 100, if the product has more than 100 variants, the variant will be replaced with the customize option. -->
  <!-- Start create variant option from option customily -->
  <template v-if="customilyVariantsOptionTags?.length">
    <template
      v-if="
        customilyDoneLoading && Object.keys(customilyVariantsOptions)?.length
      "
    >
      <div
        class="product__option"
        v-for="(customilyVariantsOption, index) in customilyVariantsOptions"
        :key="index"
      >
        <div>
          <h2>
            {{ customilyVariantsOption.name }}
            <template v-if="isCustomilyColorOption(customilyVariantsOption.tag)"
              >:
              <span class="product__option-value">
                {{
                  removeTrailingPeriod(
                    customilyVariantsOptionsActived[customilyVariantsOption.tag]
                  )
                }}
              </span>
            </template>
          </h2>
          <div class="product__option-choices">
            <span
              class="product__option-choice"
              v-for="option of customilyVariantsOption.options"
              :key="option"
              @click="
                changeCustomilyVariantsOption(
                  customilyVariantsOption.tag,
                  option
                )
              "
              :style="
                buildOptionChoiceStyle(customilyVariantsOption.type, option)
              "
              :class="{
                ...buildOptionChoiceClasses(
                  option,
                  customilyVariantsOption.name,
                  customilyVariantsOption.type
                ),
                ...{
                  'product__option-choice--actived':
                    customilyVariantsOptionsActived[
                      customilyVariantsOption.tag
                    ] == option,
                },
              }"
            >
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!customilyDoneLoading">
      <template
        v-for="(
          customilyVariantsOptionTag, index
        ) in customilyVariantsOptionTags"
        :key="index"
      >
        <div
          class="product__option"
          v-if="isCustomilyColorOption(customilyVariantsOptionTag)"
        >
          <h2>
            <sib-skeleton-loading width="6em"></sib-skeleton-loading>
          </h2>
          <div class="product__option-choices">
            <sib-skeleton-loading
              v-for="index in 3"
              :key="index"
              width="3em"
              height="3em"
              round="circle"
            ></sib-skeleton-loading>
          </div>
        </div>
        <div class="product__option" v-else>
          <h2>
            <sib-skeleton-loading width="6em"></sib-skeleton-loading>
          </h2>
          <div class="product__option-choices">
            <sib-skeleton-loading
              v-for="index in 3"
              :key="index"
              width="6em"
              height="2.5em"
            ></sib-skeleton-loading>
          </div>
        </div>
      </template>
    </template>
  </template>
  <!-- End create variant option from option customily -->

  <template v-if="productOptionChoices.length">
    <div
      class="mt-sm"
      v-if="metafieldGiftSet"
      v-html="metafieldGiftSet.value"
    ></div>
    <div
      class="product__option"
      v-for="(productOption, index) of productOptionChoices"
      :key="productOption.name"
      :class="{
        'product__option--shipped-from':
          productOption.name == OPTION_TYPE_SHIPPED_FROM,
        'product__option--shipped-from-hidden':
          productOption.name == OPTION_TYPE_SHIPPED_FROM &&
          ((product?.handle == PRODUCT_HANDLE_CAMP_WIN &&
          (HIDDEN_PRODUCED_IN_SHIPPED_FROM_CAMP_WIN == 'true' ||
            requestLocation.countryCode?.toUpperCase() != US_COUNTRY_CODE)) || 
            (product?.handle == PRODUCT_HANDLE_CAMP_GRC00424 && requestLocation.countryCode?.toUpperCase() == US_COUNTRY_CODE)),
      }"
    >
      <BuyMoreSaveMorePack
        v-if="
          productOption.name?.includes(PACK_OPTIONS) &&
          showProductBuyMoreSaveMorePack
        "
      />
      <div
        v-show="
          !productOption.name?.includes(PACK_OPTIONS) ||
          !showProductBuyMoreSaveMorePack
        "
      >
        <h2>
          {{ productOption.name }}
          {{
            shouldLoadProductDescriptionAndShippingByVariantType &&
            selectedVariantStyleOptionValue &&
            !isStyleOption(productOption.type)
              ? `for ${selectedVariantStyleOptionValue}`
              : ''
          }}

          <template
            v-if="
              isColorOption(productOption.type) ||
              (canShowOptionAsIcon && isStyleOption(productOption.type))
            "
            >:
            <span class="product__option-value">
              {{ removeTrailingPeriod(getSelectedOption(productOption.name)) }}
            </span>
          </template>
          <template v-if="index == sizeOptionIndex && sizeCharts.length">
            <span class="product__size-chart" @click="showSizeChart">
              Size Guide
            </span>
          </template>
        </h2>
        <div
          v-if="checkShowOptionTypeHtml(productOption.name)"
          class="product__option-choices"
          :class="{
            'product__option-choices--small': isSizeOption(productOption.type),
          }"
        >
          <template
            v-for="option of isOptionTypeName(productOption.name)
              ? filterOptionTypeValues(productOption.values)
              : isOptionProducedInAndShippedFromName(productOption.name)
              ? filterOptionProducedInAndShippedFromValues(productOption.values)
              : productOption.values"
            :key="option"
          >
            <span
              @click="selectOption(option, productOption.name)"
              :class="{
                'product__option-choices-html-actived': isOptionActive(
                  option,
                  productOption.name
                ),
              }"
              v-html="getProductOptionHtml(productOption.type, option)"
            ></span>
          </template>
        </div>
        <div
          v-else
          class="product__option-choices"
          :class="{
            'product__option-choices--small': isSizeOption(productOption.type),
          }"
        >
          <!-- show dropdown list when the number of option is higher than x -->
          <template
            v-if="
              ((productOption.values?.length || 0) >=
                NUMBER_OF_OPTIONS_TO_SHOW_DROPDOWN &&
                !isColorOption(productOption.type)) ||
              (isSizeOption(productOption.type) && isDropdownSizeOption()) ||
              (isColorOption(productOption.type) && isDropdownColorOption()) ||
              (isModelOptionName(productOption.name) && isDropdownModelOption())
            "
          >
            <sib-select
              size="sm"
              :key="JSON.stringify(productOption.values)"
              @input="selectOption($event, productOption.name)"
              :value="getSelectedOption(productOption.name)"
              :options="transformToSelectOptions(productOption.values)"
            ></sib-select>
          </template>

          <!-- show new style option list -->
          <template
            v-else-if="isNewStyle(product) && isStyleOption(productOption?.type)"
          >
            <span
              @click="selectOption(option, productOption.name)"
              style="cursor: pointer;"
              v-for="option of isOptionTypeName(productOption.name)
                ? filterOptionTypeValues(productOption.values)
                : isOptionProducedInAndShippedFromName(productOption.name)
                ? filterOptionProducedInAndShippedFromValues(
                    productOption.values
                  )
                : productOption.values"
              :key="option"
            >
              <img
                  v-if="getImageStyle(option, productOption.name)"
                  :class="[
                    'product__option_new-choice',
                    {
                      'product__option_new-choice-actived': isOptionActive(
                        option,
                        productOption.name
                      ),
                    },
                  ]"
                  :src="getImageStyle(option, productOption.name)"
                  :alt="option"
                  :width="100"
                  :height="100"
                  fetchpriority="low"
                  loading="lazy"
                />
            </span>
          </template>

          <!-- show normal option list -->
          <template v-else>
            <span
              class="product__option-choice"
              :style="buildOptionChoiceStyle(productOption.type, option)"
              @click="selectOption(option, productOption.name)"
              :class="{
                ...buildOptionChoiceClasses(
                  option,
                  productOption.name,
                  productOption.type
                ),
                ...{
                  [getSkuPrefixVariantProduct(option, productOption)]: [
                    getSkuPrefixVariantProduct(option, productOption),
                  ],
                },
                'product__option-choice--pack-pricing': isLeverSphereLoopProduct && productOption.name === PACK_OPTIONS
              }"
              v-for="option of getOptionList(productOption)"
              :key="option"
            >
              <template
                v-if="canShowOptionAsIcon && isStyleOption(productOption.type)"
              >
                <!-- use raw image here because firefox can not load svg inside picture element -->
                <img
                  :src="getStyleOptionIcon(option)?.value"
                  :alt="option"
                  :width="36"
                  :height="36"
                  fetchpriority="low"
                  loading="lazy"
                />
              </template>
              <template v-else>
                <!-- <span
                  class="product-option-badge"
                  v-if="
                    isOptionCustomBadge(productOption.name) &&
                    getValueBadge(option, productOption.name)
                  "
                  ><span
                    v-html="getValueBadge(option, productOption.name)"
                  ></span
                ></span> -->
                <span class="option-text-wrapper">
                  <span class="option-label">{{ formatOptionLabel(option, productOption) }}</span>
                  <span v-if="productOption.name === PACK_OPTIONS && getPackPricePerPieceHtml(option, productOption)" class="option-price-per-piece">
                    {{ getPackPricePerPieceHtml(option, productOption) }}
                  </span>
                </span>
              </template>
            </span>
          </template>
        </div>
        <template
          v-if="index == shippedFromOptionIndex && numberShippedFromOption > 1"
        >
          <span class="product__small-label" @click="showShippedFromPopup">
            See the Shipping Time Difference
          </span>
        </template>

        <template
          v-if="
            productOption.name == PACK_OPTIONS &&
            (showProductBuyMoreSaveMorePack ||
              isProductHasTags(productStore.product, [
                PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE,
              ]))
          "
        >
          <input
            v-for="(packOption, i) in productOption.values"
            :key="i"
            type="hidden"
            :name="`properties[_${packOption}]`"
            :value="
              getPriceProductByTypeAndPackOption(
                getSelectedOption(TYPE_OPTIONS),
                getSelectedOption(SIZE_OPTIONS),
                packOption
              )
            "
          />
          <input
            type="hidden"
            :name="`properties[${PACK_TYPE}]`"
            :value="getSelectedOption(TYPE_OPTIONS) || ''"
          />
        </template>
      </div>
    </div>

    <input
      type="hidden"
      :name="`properties[${PRODUCT_PACK}]`"
      :value="isProductPackOption"
    />
  </template>
  <template v-else>
    <div class="product__option">
      <h2>
        <sib-skeleton-loading width="10em"></sib-skeleton-loading>
      </h2>
      <div class="product__option-choices">
        <sib-skeleton-loading
          v-for="index in 3"
          :key="index"
          width="3.4em"
          height="3.4em"
        ></sib-skeleton-loading>
      </div>
    </div>
    <div class="product__option">
      <h2>
        <sib-skeleton-loading width="6em"></sib-skeleton-loading>
      </h2>
      <div class="product__option-choices">
        <sib-skeleton-loading
          v-for="index in 3"
          :key="index"
          width="3em"
          height="3em"
          round="circle"
        ></sib-skeleton-loading>
      </div>
    </div>
    <div class="product__option">
      <h2>
        <sib-skeleton-loading width="4em"></sib-skeleton-loading>
      </h2>
      <div class="product__option-choices">
        <sib-skeleton-loading
          v-for="index in 6"
          :key="index"
          width="2.5em"
          height="2.5em"
        ></sib-skeleton-loading>
      </div>
    </div>
  </template>

  <!-- Because the maximum variant is 100, if the product has more than 100 variants, the variant will be replaced with the customize option. -->
  <!-- Start create variant option from option customily -->
  <!-- Use logic for tag has tag prefix last-customily-variants -->
  <template v-if="lastCustomilyVariantsOptionTags?.length">
    <template
      v-if="
        customilyDoneLoading &&
        Object.keys(lastCustomilyVariantsOptions)?.length
      "
    >
      <div
        class="product__option"
        v-for="(customilyVariantsOption, index) in lastCustomilyVariantsOptions"
        :key="index"
      >
        <div>
          <h2>
            {{ customilyVariantsOption.name }}
            <template v-if="isCustomilyColorOption(customilyVariantsOption.tag)"
              >:
              <span class="product__option-value">
                {{
                  removeTrailingPeriod(
                    lastCustomilyVariantsOptionsActived[
                      customilyVariantsOption.tag
                    ]
                  )
                }}
              </span>
            </template>
          </h2>
          <div class="product__option-choices">
            <span
              class="product__option-choice"
              v-for="option of customilyVariantsOption.options"
              :key="option"
              @click="
                changeLastCustomilyVariantsOption(
                  customilyVariantsOption.tag,
                  option
                )
              "
              :style="
                buildOptionChoiceStyle(customilyVariantsOption.type, option)
              "
              :class="{
                ...buildOptionChoiceClasses(
                  option,
                  customilyVariantsOption.name,
                  customilyVariantsOption.type
                ),
                ...{
                  'product__option-choice--actived':
                    lastCustomilyVariantsOptionsActived[
                      customilyVariantsOption.tag
                    ] == option,
                },
              }"
            >
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!customilyDoneLoading">
      <template
        v-for="(
          customilyVariantsOptionTag, index
        ) in lastCustomilyVariantsOptionTags"
        :key="index"
      >
        <div
          class="product__option"
          v-if="isCustomilyColorOption(customilyVariantsOptionTag)"
        >
          <h2>
            <sib-skeleton-loading width="6em"></sib-skeleton-loading>
          </h2>
          <div class="product__option-choices">
            <sib-skeleton-loading
              v-for="index in 3"
              :key="index"
              width="3em"
              height="3em"
              round="circle"
            ></sib-skeleton-loading>
          </div>
        </div>
        <div class="product__option" v-else>
          <h2>
            <sib-skeleton-loading width="6em"></sib-skeleton-loading>
          </h2>
          <div class="product__option-choices">
            <sib-skeleton-loading
              v-for="index in 3"
              :key="index"
              width="6em"
              height="2.5em"
            ></sib-skeleton-loading>
          </div>
        </div>
      </template>
    </template>
  </template>
  <!-- End create variant option from option customily -->

  <client-only>
    <ProductShippedFromPopup ref="shippedFromPopup"></ProductShippedFromPopup>
  </client-only>
</template>

<script lang="ts" setup>
import { ComputedRef, computed, onMounted, ref, watch } from 'vue'
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import { SelectedOption, ProductOption, KeyValue } from '@/types'
import useRequestLocationStore from '@/store/requestLocation'
import {
  removeTrailingPeriod,
  cloneDeep,
  MODEL_OPTIONS_NAME,
  OPTION_TYPE_SIZE,
  OPTION_TYPE_COLOR,
  OPTION_TYPE_STYLE,
  NEW_STYLE,
  NUMBER_OF_OPTIONS_TO_SHOW_DROPDOWN,
  EVENT_TRACKING_SHOW_PRODUCT_SIZE_GUIDE,
  EVENT_TRACKING_PRODUCT_SIZE_GUIDE_OPENED,
  OPTION_TYPE_SHIPPED_FROM,
  EVENT_TRACKING_PRODUCT_SHIPPED_FROM_OPENED,
  AB_TEST_VARIANT_DEFAULT_OVERSEA,
  AB_TEST_VARIANT_DEFAULT_US,
  AB_TEST_CODE_SHOW_PRODUCT_SHIPPED_FROM_OPTION,
  AB_TEST_SHOW_NEW_OPTION_PRODUCT_CHRISTMAS_TUMBLER,
  MIXPANEL_DESTINATION,
  destinationIntegrations,
  PACK_TYPE,
  PRODUCT_PACK,
  US_COUNTRY_CODE,
  AB_TEST_VARIANT_SHOW_ALL,
  PACK_OPTIONS,
  TYPE_OPTIONS,
  COLOR_OPTIONS,
  SIZE_OPTIONS,
  CAMPAIGN_DISCOUNT_BLACKFRIDAY9,
  PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE,
  AB_TEST_NEW_PRICE_BASE_ON_PRODUCT_TYPE,
  AB_TEST_OPTION_SIZE_PRICE,
  AB_TEST_VARIANT_NEW_PRICE,
  EVENT_ABTEST_ASSIGNED,
  OPTION_NAME_TYPE,
  AB_TEST_VARIANT_DISABLE,
  PRODUCT_TAG_IGN_PACK_DISCOUNT,
  PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE,
  PRODUCT_HANDLE_CAMP_GRC00424,
  HIDDEN_PRODUCED_IN_SHIPPED_FROM_CAMP_WIN,
  PRODUCT_HANDLE_CAMP_WIN,
  AB_TEST_VARIANT_ENABLE,
  PRODUCT_HANDLES_NO_APPLY_PACK_DISCOUNT,
  QUERY_STRING_UTM_CAMPAIGN,
  EVENT_CUSTOMILY_DONE_LOADING,
  CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR,
  PRODUCT_TAG_CUSTOMILY_VARIANTS_OPTION_PREFIX,
  PRODUCT_TAG_LAST_CUSTOMILY_VARIANTS_OPTION_PREFIX,
  INPUT_CUSTOMILY_SWATCH_SELECTOR,
  EVENT_TRACKING_PRODUCT_OPTION_SELECTED,
  BLOCKED_PREFIXES,
} from '@/utils'
import { isProductHasTags, standardizeOptionValue, formatPrice } from '@/utils/product'
import type { Fancybox as FancyboxType } from '@fancyapps/ui'
import Analytics from '@/services/analytics'
import { useRoute } from 'vue-router'
import ProductShippedFromPopup from './ProductShippedFromPopup.vue'
import BuyMoreSaveMorePack from './BuyMoreSaveMorePack.vue'
import { useABTest } from '@/composables/useABTest'
import LocationService, { UserLocation } from '@/services/location'
import useDiscountStore from '@/store/discount'
import EventBus from '@/services/eventbus'
import { isOnServer } from '@/utils/ssr.js'

const route = useRoute()
const productStore = useProductStore()
const settingStore = useSettingStore()
const discountStore = useDiscountStore()
const { getABTestActivedVariantByCode } = useABTest()

const handlesAbTestShowNewOptionProductChristmasTumbler = [
  'merry-grinchmas-personalized-stole-christmas-tumbler-12201023001scl1tmm1th06nh02an01tbl1grc5385',
]
const METAFIELD_NAME_SPACE_CUSTOM = 'custom'
const METAFIELD_KEY_GIFT_SET = 'gift_set'

let Fancybox: FancyboxType | null = null
const shippedFromPopup = ref<typeof ProductShippedFromPopup | null>(null)
const product = computed(() => productStore.product)
const isLeverSphereLoopProduct = computed(() => {
  const hasTag = isProductHasTags(product.value, ['leversphere_customizer'])
  const config = productStore.productTemplateConfig
  
  if (!hasTag || !config) return false

  let loopEnabled = false
  if (Array.isArray(config)) {
    loopEnabled = config.some((styleItem: any) =>
      styleItem.templates?.some((t: any) => !!t.ui_options?.is_loopable || !!t.loopConfig?.enabled || !!t.loop_config?.enabled)
    )
  } else {
    loopEnabled = !!config.ui_options?.is_loopable || 
                  !!config.loop_config?.enabled || 
                  !!config.loopConfig?.enabled
  }

  return loopEnabled
})
const pageSettings = computed(() => settingStore.pages)

const customilyDoneLoading = ref(false)
const customilyVariantsOptionsActived = ref({})
const customilyVariantsOptions = ref([])
const lastCustomilyVariantsOptionsActived = ref({})
const lastCustomilyVariantsOptions = ref([])

const customilyVariantsOptionTags = computed(() => {
  return (product.value?.tags || []).filter((tag) =>
    tag.startsWith(PRODUCT_TAG_CUSTOMILY_VARIANTS_OPTION_PREFIX)
  )
})
const lastCustomilyVariantsOptionTags = computed(() => {
  return (product.value?.tags || []).filter((tag) =>
    tag.startsWith(PRODUCT_TAG_LAST_CUSTOMILY_VARIANTS_OPTION_PREFIX)
  )
})

const isCampaignDiscountBlackfriday9 = computed(
  () =>
    discountStore.campaignDiscountCode?.toLowerCase() ==
    CAMPAIGN_DISCOUNT_BLACKFRIDAY9
)

const selectedVariant = computed(() => {
  return productStore.selectedVariant
})

const sizeCharts = computed(() =>
  (productStore.productDescription?.size_guide?.split(',') || []).map((url) =>
    url.trim()
  )
)

const shouldLoadProductDescriptionAndShippingByVariantType = computed(
  () => productStore.shouldLoadProductDescriptionAndShippingByVariantType
)

const selectedVariantStyleOptionValue = computed(
  () => productStore.selectedVariantStyleOptionValue
)

interface StyleOptions {
  productTypeToShowIcon: Array<string>
  variantTypeIconMap: Array<KeyValue>
  productTypeToShowDropdownColorOption: Array<string>
  productTypeToShowDropdownSizeOption: Array<string>
}

const colorOptions: ComputedRef<Array<KeyValue>> = computed(
  () => settingStore.baseProductPage?.colorOptions || []
)

const aiMultiPoseConfig = computed(() =>
  isProductHasTags(productStore.product, ['AI_multi_pose'])
    ? settingStore.baseProductPage?.productOptionsAISettings?.find(
        (item: any) => item.handle === productStore.product?.handle
      )
    : null
)

const productOptionsHtml = computed(
  () => settingStore.baseProductPage?.productOptions || []
)

const styleOptions: ComputedRef<StyleOptions> = computed(
  () => settingStore.baseProductPage?.styleOptions || {}
)

interface ProductOptionRecursive {
  name: string
  values: Array<{
    value: string
    childs: ProductOptionRecursive[]
    valuesSkuPrefix?: any
  }>
}

// product options that restrict which option is available when another options is choosen
const productOptions: ComputedRef<Array<ProductOptionRecursive>> = computed(
  () => {
    const options: ProductOptionRecursive[] = []
    if (!product.value?.variants) return options
    product.value.variants.forEach((variant) => {
      if (!variant.selectedOptions || !variant.selectedOptions.length) return
      if (variant?.skuPrefix && BLOCKED_PREFIXES.includes(variant?.skuPrefix)) {
        return
      }

      buildOption(
        options,
        variant.selectedOptions[0],
        variant.selectedOptions.slice(1),
        variant?.skuPrefix
      )
    })
    return options
  }
)
const requestLocation = useRequestLocationStore()

const isHideShippedFromOption = computed(() => {
  if (!product.value) return false
  if (requestLocation.countryCode?.toUpperCase() != US_COUNTRY_CODE) {
    return true
  }

  const abtestVariant = getABTestActivedVariantByCode(
    AB_TEST_CODE_SHOW_PRODUCT_SHIPPED_FROM_OPTION
  )
  if (abtestVariant === null) return false
  if (
    abtestVariant === AB_TEST_VARIANT_DEFAULT_OVERSEA ||
    abtestVariant === AB_TEST_VARIANT_DEFAULT_US
  ) {
    return true
  }
  return false
})

const isHideNewOptionProductChristmasTumbler = computed(() => {
  if (!product.value) return false

  if (
    !handlesAbTestShowNewOptionProductChristmasTumbler.includes(
      product.value.handle
    )
  )
    return false

  const abtestVariant = getABTestActivedVariantByCode(
    AB_TEST_SHOW_NEW_OPTION_PRODUCT_CHRISTMAS_TUMBLER
  )
  if (abtestVariant === null) return false
  if (abtestVariant === AB_TEST_VARIANT_DISABLE) {
    return true
  }
  return false
})

// options that are available for the current variant
const productOptionChoices = computed(() => {
  if (!product.value) return []
  if (!selectedVariant.value?.selectedOptions || !productOptions.value?.length)
    return product.value.options
  const clonedSelectedOptions = cloneDeep(selectedVariant.value.selectedOptions)
  let result: Array<ProductOption> = []
  buildOptionChoices(productOptions.value, result, clonedSelectedOptions)
  if (isHideShippedFromOption.value) {
    result = result.filter(
      (optionChoice) => optionChoice.name !== OPTION_TYPE_SHIPPED_FROM
    )
  }
  if (isHideNewOptionProductChristmasTumbler.value) {
    result = result.filter(
      (optionChoice) => optionChoice.name !== OPTION_NAME_TYPE
    )
  }
  return result
})

const isProductPackOption = computed(() => {
  const index = productOptionChoices.value.findIndex(
    (option) => option.name == PACK_OPTIONS
  )
  return index != -1
})

const showProductBuyMoreSaveMorePack = computed(
  () =>
    !isProductHasTags(productStore.product, [
      PRODUCT_TAG_IGN_PACK_DISCOUNT,
      PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE,
    ])
)

const sizeOptionIndex = computed(() => {
  for (let i = 0; i < productOptionChoices.value.length; i++) {
    if (isSizeOption(productOptionChoices.value[i].type)) {
      return i
    }
  }
  return 0
})

const shippedFromOptionIndex = computed(() => {
  return productOptionChoices.value.findIndex(
    (optionChoice) => optionChoice.name === OPTION_TYPE_SHIPPED_FROM
  )
})

const numberShippedFromOption = computed(() => {
  const shippedFromOption = productOptionChoices.value.find(
    (optionChoice) => optionChoice.name === OPTION_TYPE_SHIPPED_FROM
  )
  if (!shippedFromOption) return 0
  return shippedFromOption?.values?.length || 0
})

// can show style options as icons or not
const canShowOptionAsIcon: ComputedRef<boolean> = computed(() => {
  if (
    !product.value ||
    !styleOptions.value ||
    !styleOptions.value.productTypeToShowIcon ||
    !styleOptions.value.variantTypeIconMap
  )
    return false
  const productType = (product.value.productType || '')
    .toLowerCase()
    .replaceAll(' ', '')
  // show style options as icons for ony some product that have product type in the list
  if (!styleOptions.value.productTypeToShowIcon?.includes(productType))
    return false
  if (!productOptionChoices.value?.length) return false
  // show style options as icons only for product that have all style value in the icon list
  for (let i = 0; i < productOptionChoices.value.length; i++) {
    const productOption = productOptionChoices.value[i]
    if (isStyleOption(productOption.type) && productOption.values) {
      for (let j = 0; j < productOption.values.length; j++) {
        const value = productOption.values[j]
        if (!value) return false
        const standardValue = standardizeOptionValue(value)
        const styleOption = styleOptions.value.variantTypeIconMap.find(
          (elm) => elm.key == standardValue
        )
        if (!styleOption) return false
      }
    }
  }
  return true
})

const metafieldGiftSet = computed(() => {
  return productStore.product?.metafields?.find(
    (item) =>
      item &&
      item.namespace == METAFIELD_NAME_SPACE_CUSTOM &&
      item.key == METAFIELD_KEY_GIFT_SET
  )
})

const isNewPriceBaseOnProductType = computed(() => {
  const abtestVariant = getABTestActivedVariantByCode(
    AB_TEST_NEW_PRICE_BASE_ON_PRODUCT_TYPE
  )
  return abtestVariant == AB_TEST_VARIANT_NEW_PRICE
})

const isNewOptionSizePrice = computed(() => {
  const abtestVariant = getABTestActivedVariantByCode(AB_TEST_OPTION_SIZE_PRICE)
  return abtestVariant == AB_TEST_VARIANT_NEW_PRICE
})

onMounted(() => {
  watch(
    () => sizeOptionIndex.value,
    async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal) {
        trackingEvent(EVENT_TRACKING_SHOW_PRODUCT_SIZE_GUIDE)
      }
    },
    { immediate: true }
  )
  watch(
    () => productOptionChoices.value,
    async () => {
      // only show all option from shipped in US location on mode AB test
      // so hide product option shipped if ab test variant is show_all and location is not US
      LocationService.onLocationReady(async (location: UserLocation | null) => {
        const countryCode = location?.country_code.toLowerCase()
        const optionShippedElement = document.querySelector(
          '.product__option--shipped-from'
        )
        const abtestVariant = getABTestActivedVariantByCode(
          AB_TEST_CODE_SHOW_PRODUCT_SHIPPED_FROM_OPTION
        )
        if (!optionShippedElement) return
        if (
          abtestVariant == AB_TEST_VARIANT_SHOW_ALL &&
          countryCode != US_COUNTRY_CODE.toLowerCase()
        ) {
          optionShippedElement.style.display = 'none'
        }
      })

      // hidden option color 'Purple' for product type Accent Mug with option size '15oz'
      // because the product is out of stock
      const productAccentMugWrap =
        document.querySelector('.product-type__AccentMug') ||
        document.querySelector('.product-type__AccentMugAndCoaster')

      if (productAccentMugWrap) {
        const optionColorPurple = document.querySelector(
          '.product-color__purple'
        )
        if (optionColorPurple) {
          if (selectedVariant.value?.title?.includes('15oz')) {
            optionColorPurple.style.display = 'none'
            if (selectedVariant.value?.title?.includes('Purple')) {
              const firstVariantHasTitle15Oz = product.value.variants.find(
                (item) => item.title?.includes('15oz')
              )
              if (firstVariantHasTitle15Oz) {
                productStore.selectedVariant = firstVariantHasTitle15Oz
              } else {
                productStore.selectedVariant = product.value.variants[0]
              }
            }
          } else {
            optionColorPurple.style.display = 'block'
          }
        }
      }

      const productFullPrintPhoneCaseWrap = document.querySelector(
        '.product-type__FullPrintPhoneCase'
      )
      if (productFullPrintPhoneCaseWrap) {
        const optionDevicesHidden = [
          'Samsung S7',
          'Samsung S7 Edge',
          'Samsung S8',
          'Samsung S8 Plus',
          'Samsung Note 8',
          'Samsung S9',
          'Samsung S9 Plus',
          'Samsung Note 9',
          'Samsung S10 E',
          'Samsung S10',
          'Samsung S10 Plus',
          'Samsung Note 10',
          'Samsung Note 10 Plus',
          'Samsung S20',
          'Samsung S20 Plus',
          'Samsung S20 Ultra',
          'Samsung Note20',
          'Samsung Note20 Ultra',
          'Samsung S21',
          'Samsung S21 Plus',
          'Samsung S21 Ultra',
        ]

        optionDevicesHidden.forEach((item) => {
          const option = productFullPrintPhoneCaseWrap.querySelector(
            `select option[value="${item}"]`
          )
          if (option) option.remove()
        })
      }
    },
    { immediate: true }
  )

  fillOptionDataSelect()

  // hide option size 8 inch when product has tag 'last_hide_size_variant' và has utm_source=fb
  const hasLastHideSizeVariantTag = isProductHasTags(productStore.product, [
    'last_hide_size_variant',
  ])
  const utmSource = route.query['utm_source'] as string
  if (utmSource?.toLowerCase()?.includes('fb') && hasLastHideSizeVariantTag) {
    const optionSize8inch = document.querySelector(
      '.product_option-choice-size--8'
    )
    if (optionSize8inch) optionSize8inch.style.display = 'none'
  }

  // AB Test option size price
  if (
    productStore.product?.handle?.includes(
      '10692140425scl1tmm1tr04cu03li09hsp1_ipatumcr00002'
    )
  ) {
    let variantIndexNeedRemove = -1
    if (isNewOptionSizePrice.value) {
      variantIndexNeedRemove = productStore.product?.variants?.findIndex(
        (item) => item.id.includes('50548533002522') // variant default price ab test
      )
    } else {
      variantIndexNeedRemove = productStore.product?.variants?.findIndex(
        (item) => item.id.includes('50676567736602') // variant new price ab test
      )
    }
    if (variantIndexNeedRemove > -1) {
      productStore.product.variants.splice(variantIndexNeedRemove, 1)
    }

    trackingABTestOptionSizePrice()
  }

  EventBus.on(EVENT_CUSTOMILY_DONE_LOADING, () => {
    customilyDoneLoading.value = true
    if (customilyVariantsOptionTags.value.length) {
      for (let i = 0; i < customilyVariantsOptionTags.value.length; i++) {
        getCustomilyVariantsOptionValue(customilyVariantsOptionTags.value[i])
      }
    }
    if (lastCustomilyVariantsOptionTags.value.length) {
      for (let i = 0; i < lastCustomilyVariantsOptionTags.value.length; i++) {
        getLastCustomilyVariantsOptionValue(
          lastCustomilyVariantsOptionTags.value[i]
        )
      }
    }
  })

  trackingABTestNewPriceBaseOnProductType()
  trackingABTestShowNewOptionProductChristmasTumbler()
})

function buildOptionChoices(
  productOptions: ProductOptionRecursive[],
  optionChoices: Array<ProductOption>,
  selectedOptions: Array<SelectedOption>
) {
  const selectedOption = selectedOptions.shift()
  if (!selectedOption) return

  const productOption = productOptions.find(
    (option) => option.name === selectedOption.name
  )
  if (!productOption) return
  if (productOption.name.toLowerCase() == 'model') {
    // hide options phone case because they are out of stock
    const skuPhoneCaseNeedHide = [
      'LPC101',
      'LPC102',
      'LPC103',
      'LPC104',
      'LPC105',
      'LPC106',
      'LPC110',
      'LPC111',
      'LPC115',
      'LPC117',
      'LPC132',
      'LPC133',
      'LPC149',
      'LPC150',
      'LPC151',
      'LPC152',
      'LPC153',
      'LPC154',
      'LPC155',
      'LPC156',
      'LPC157',
      'LPC158',
      'LPC159',
      'LPC160',
      'LPC161',
      'LPC162',
      'LPC163',
      'LPC164',
    ]
    let productOptionValues = []
    productOptionValues = productOption.values.filter(
      (item) =>
        !skuPhoneCaseNeedHide.includes(item.valuesSkuPrefix.toUpperCase())
    )
    optionChoices.push({
      name: productOption.name,
      values: productOptionValues.map((option) => option.value),
      type: selectedOption.type,
      valuesSkuPrefix: productOption.values.map((option) => ({
        value: option?.valuesSkuPrefix,
        option: option?.value,
      })),
    })
  } else {
    optionChoices.push({
      name: productOption.name,
      values: productOption.values.map((option) => option.value),
      type: selectedOption.type,
      valuesSkuPrefix: productOption.values.map((option) => ({
        value: option?.valuesSkuPrefix,
        option: option?.value,
      })),
    })
  }

  const selectedProductOption = productOption.values.find(
    (option) => option.value === selectedOption.value
  )
  if (!selectedProductOption?.childs?.length) return

  buildOptionChoices(
    selectedProductOption.childs,
    optionChoices,
    selectedOptions
  )
}

function fillOptionDataSelect() {
  // Because we hide some variants sku LCP , the first option of the select element has no value and is displayed blank.
  // We need to use this function to fill data into the select element.
  setTimeout(() => {
    let selectElement = document.querySelector(
      '.product__option-choices .select--default'
    )
    if (
      selectElement &&
      selectElement.value !== selectElement.options[0].value
    ) {
      selectElement.selectedIndex = 0
      selectElement.dispatchEvent(new Event('change'))
    }
  }, 1000)
}

function buildOption(
  parentOptions: ProductOptionRecursive[],
  selectedOption: SelectedOption,
  childOptions: SelectedOption[],
  skuPrefixOption?: any
): any {
  let option = parentOptions.find((o) => o.name === selectedOption.name)
  if (!option) {
    option = {
      name: selectedOption.name,
      values: [],
    }
    parentOptions.push(option)
  }

  let value = option.values.find((v) => v.value === selectedOption.value)
  if (!value) {
    value = {
      value: selectedOption.value,
      valuesSkuPrefix: skuPrefixOption,
      childs: [],
    }
    option.values.push(value)
  }
  if (childOptions.length) {
    return buildOption(
      value.childs,
      childOptions[0],
      childOptions.slice(1),
      skuPrefixOption
    )
  }
}
const sizeClickCount = ref(0);
function selectOption(option: string, name?: string) {
  if (!name) return
  if (!product.value?.variants || !selectedVariant.value?.selectedOptions)
    return
  if (name == "Size") {
    sizeClickCount.value++;
    try {
      Analytics.track(EVENT_TRACKING_PRODUCT_OPTION_SELECTED, {
        option_type: 'size',
        option_value: option,
        click_count: sizeClickCount.value,
      })
    } catch (e) {
      console.log(e)
    }
  }
  
  const clonedSelectedOptions = cloneDeep(selectedVariant.value.selectedOptions)
  const selectedIndex = clonedSelectedOptions.findIndex((o) => o.name === name)
  clonedSelectedOptions.splice(selectedIndex, 1, {
    name,
    value: option,
  })
  const clonedSelectedOptionsValue = clonedSelectedOptions
    .map((o) => o.value)
    .join('')
  if (!clonedSelectedOptionsValue) return

  let newSelectedVariant = product.value.variants.find((variant) => {
    return clonedSelectedOptionsValue === variant.selectedOptionsValue
  })

  if (!newSelectedVariant) {
    let filteredVariants = product.value.variants

    for (let i = 0; i < clonedSelectedOptions.length; i++) {
      const prevFilteredVariants = filteredVariants
      filteredVariants = filteredVariants.filter((variant) => {
        if (!variant.selectedOptions || !variant.selectedOptions.length)
          return false
        return (
          variant.selectedOptions[i].value === clonedSelectedOptions[i].value
        )
      })
      if (!filteredVariants.length) {
        filteredVariants = prevFilteredVariants
        break
      }
    }
    newSelectedVariant = filteredVariants[0]
  }
  if (newSelectedVariant) {
    productStore.selectedVariant = newSelectedVariant
    productStore.didUserChooseVariant = true
  }
  if (option == 'For iPhone' || option == 'For Samsung') {
    // Because we hide some variants sku LCP , the first option of the select element has no value and is displayed blank.
    // We need to use this function to fill data into the select element.
    fillOptionDataSelect()
  }
}

function getSelectedOption(name: string = '') {
  if (!selectedVariant.value?.selectedOptions) return ''
  const selectedOption = selectedVariant.value.selectedOptions.find(
    (o) => o.name === name
  )
  if (!selectedOption) return ''
  return selectedOption.value
}

function isOptionActive(option: string, name?: string) {
  if (!option) return false
  return option === getSelectedOption(name)
}

function isSizeOption(optionType: string = '') {
  return optionType === OPTION_TYPE_SIZE
}

function isColorOption(optionType: string = '') {
  return optionType === OPTION_TYPE_COLOR
}

function isStyleOption(optionType: string = '') {
  return optionType === OPTION_TYPE_STYLE
}

function isOptionTypeName(optionTypName: string = '') {
  return optionTypName === TYPE_OPTIONS
}

function isOptionColorName(optionTypName: string = '') {
  return optionTypName === COLOR_OPTIONS
}

function isModelOptionName(optionTypName: string = '') {
  return optionTypName === MODEL_OPTIONS_NAME
}

function isOptionProducedInAndShippedFromName(optionTypName: string = '') {
  return optionTypName === OPTION_TYPE_SHIPPED_FROM
}

function isNewStyle(product) {
  const productTag = product?.tags.find((tag) => NEW_STYLE === tag)
  return productTag
}

function isIconOption(optionType: string = '', optionValue: string = '') {
  if (!styleOptions.value) return false

  if (
    !styleOptions.value.productTypeToShowIcon?.includes(
      product.value?.productType || ''
    )
  ) {
    return false
  }
  return optionType === 'icon'
}

function buildOptionChoiceClasses(
  optionValue: string = '',
  optionName: string = '',
  optionType: string = ''
) {
  const optionColorClass = buildOptionColorClass(optionType, optionValue)
  const optionTypeClass = !isColorOption(optionType)
    ? `product_option-choice-${optionType.replace(/\s/g, '-')}--${optionValue
        .replace(/\s/g, '-')
        .replaceAll('"', '')
        .replaceAll('.', '')}`
    : ''
  return {
    'product__option-choice--actived': isOptionActive(optionValue, optionName),
    'product__option-choice--small': isSizeOption(optionType),
    'product__option-choice--round':
      isColorOption(optionType) && optionName !== "Choose Light's Color", // Show type Choose Light's Color default style
    'product__option-choice--icon':
      canShowOptionAsIcon.value && isStyleOption(optionType),
    [optionColorClass]: optionColorClass,
    [optionTypeClass]: optionTypeClass,
  }
}

function buildOptionChoiceStyle(
  optionType: string = '',
  optionValue: string = ''
) {
  if (!isColorOption(optionType)) return {}
  const standardOptionValue = optionValue.toLowerCase().replace(/\s/g, '-')
  const colorOption = colorOptions.value.find(
    (elm) => elm.key == standardOptionValue
  )
  if (!colorOption) return {}
  if (colorOption.value.startsWith('https')) {
    return {
      backgroundImage: `url(${colorOption.value})`,
    }
  }
  return {
    backgroundColor: colorOption.value,
  }
}

function buildOptionColorClass(
  optionType: string = '',
  optionValue: string = ''
) {
  if (isColorOption(optionType)) {
    const standardOptionValue = optionValue.toLowerCase().replace(/\s/g, '-')
    const colorOption = colorOptions.value.find(
      (elm) => elm.key == standardOptionValue
    )
    if (colorOption && colorOption.key) {
      return `product-color__${colorOption.key}`
    }
  }
}

function getStyleOptionIcon(optionValue: string) {
  const standardValue = standardizeOptionValue(optionValue)
  return styleOptions.value.variantTypeIconMap.find(
    (elm) => elm.key == standardValue
  )
}

function getImageStyle(option: string, name?: string) {
  if (!name) return
  if (!product.value?.variants || !selectedVariant.value?.selectedOptions)
    return

  const clonedSelectedOptions = cloneDeep(selectedVariant.value.selectedOptions)
  const selectedIndex = clonedSelectedOptions.findIndex((o) => o.name === name)
  clonedSelectedOptions.splice(selectedIndex, 1, {
    name,
    value: option,
  })
  const clonedSelectedOptionsValue = clonedSelectedOptions
    .map((o) => o.value)
    .join('')
  if (!clonedSelectedOptionsValue) return

  let newSelectedVariant = product.value.variants.find((variant) => {
    return clonedSelectedOptionsValue === variant.selectedOptionsValue
  })

  const imageId = newSelectedVariant?.image?.id;
  const images = product?.value?.images || [];

  const image = images.find(img => img.id === imageId);
  const imageUrl = image?.url;

  return imageUrl
}

function transformToSelectOptions(values: string[] = []) {
  return values.map((value) => ({
    value,
    label: value,
  }))
}

async function showSizeChart() {
  if (!sizeCharts.value.length) return
  if (!Fancybox) Fancybox = (await import('@fancyapps/ui')).Fancybox

  if (
    product.value?.handle == PRODUCT_HANDLE_CAMP_WIN &&
    productStore.selectedShippedOption == 'US'
  ) {
    // logic show size for camp mth7138
    Fancybox.show([
      {
        src: 'https://cdn.shopify.com/s/files/1/0724/5037/5985/files/size-guide-us.png?v=1714236146',
        type: 'image',
      },
    ])
  } else {
    Fancybox.show(
      sizeCharts.value.map((image) => ({
        src: image,
        type: 'image',
      }))
    )
  }
  trackingEvent(EVENT_TRACKING_PRODUCT_SIZE_GUIDE_OPENED)
}

function trackingEvent(event: string) {
  if (!productStore.product) return
  Analytics.track(
    event,
    {
      handle: productStore.product.handle,
      tags: productStore.product.tags,
      path: route.path,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

async function showShippedFromPopup() {
  if (!shippedFromPopup.value) return
  shippedFromPopup.value.show()
  trackingEvent(EVENT_TRACKING_PRODUCT_SHIPPED_FROM_OPENED)
}

function isDropdownColorOption() {
  if (!product.value?.productType) return
  return styleOptions.value.productTypeToShowDropdownColorOption?.includes(
    product.value.productType
  )
}

function isDropdownSizeOption() {
  if (!product.value?.productType) return
  return styleOptions.value.productTypeToShowDropdownSizeOption?.includes(
    product.value.productType
  )
}

function isDropdownModelOption() {
  if (!product.value?.productType) return
  return styleOptions.value.productTypeToShowDropdownModelOption?.includes(
    product.value.productType
  )
}

function getPriceProductByTypeAndPackOption(
  typeSelected: string,
  sizeSelected: string,
  packOption: string
) {
  if (!packOption) return
  if (!product.value?.variants) return

  const productByTypeAndPackOption = product.value.variants.find((item) => {
    if (!item.selectedOptions?.length) return false
    const indexPackOption = item.selectedOptions.findIndex(
      (option) => option.name == PACK_OPTIONS && option.value == packOption
    )
    if (typeSelected && sizeSelected) {
      const indexTypeOption = item.selectedOptions.findIndex(
        (option) => option.name == TYPE_OPTIONS && option.value == typeSelected
      )
      const indexSizeOption = item.selectedOptions.findIndex(
        (option) => option.name == SIZE_OPTIONS && option.value == sizeSelected
      )
      if (
        indexTypeOption != -1 &&
        indexSizeOption != -1 &&
        indexPackOption != -1
      )
        return true
    } else if (typeSelected) {
      const indexTypeOption = item.selectedOptions.findIndex(
        (option) => option.name == TYPE_OPTIONS && option.value == typeSelected
      )
      if (indexTypeOption != -1 && indexPackOption != -1) return true
    } else if (sizeSelected) {
      const indexSizeOption = item.selectedOptions.findIndex(
        (option) => option.name == SIZE_OPTIONS && option.value == sizeSelected
      )
      if (indexSizeOption != -1 && indexPackOption != -1) return true
    } else {
      if (indexPackOption != -1) return true
    }
    return false
  })

  if (productByTypeAndPackOption) {
    const price = productByTypeAndPackOption.priceV2?.amount || 0
    return isCampaignDiscountBlackfriday9.value
      ? price *
          ((100 - PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE) / 100)
      : price
  }
}

function filterOptionTypeValues(optionsValues?: string[]) {
  if (!optionsValues) return optionsValues
  let newOptionValues = []

  // ab test for variant product with 2 different price
  if (isNewPriceBaseOnProductType.value) {
    const optionValuesEndWithDots = optionsValues.filter((optionsValue) =>
      optionsValue?.endsWith('.')
    )
    newOptionValues = optionsValues.filter(
      (optionsValue) =>
        optionValuesEndWithDots.every((item) => !item.includes(optionsValue)) ||
        optionsValue?.endsWith('.')
    )
  } else {
    newOptionValues = optionsValues.filter(
      (optionsValue) => !optionsValue?.endsWith('.')
    )
  }

  return newOptionValues
}

function getSkuPrefixVariantProduct(option: string, productOption: any) {
  if (!productOption?.valuesSkuPrefix?.length) return ''
  const valueSkuPrefix = productOption?.valuesSkuPrefix?.find(
    (item: any) => item.option == option
  )
  return valueSkuPrefix?.value?.toLowerCase() || ''
}

// logic show size for camp mth7138
function filterOptionProducedInAndShippedFromValues(optionsValues?: string[]) {
  if (!optionsValues) return optionsValues
  let newOptionValues = []

  if (requestLocation.countryCode?.toUpperCase() == US_COUNTRY_CODE) {
    newOptionValues = optionsValues.filter(
      (optionsValue) => !optionsValue.includes('Overseas.')
    )
  } else {
    newOptionValues = optionsValues
  }

  return newOptionValues
}

function trackingABTestNewPriceBaseOnProductType() {
  if (!product.value) return
  const abtestVariant = getABTestActivedVariantByCode(
    AB_TEST_NEW_PRICE_BASE_ON_PRODUCT_TYPE
  )
  if (abtestVariant === null) return
  const payload = {
    name: AB_TEST_NEW_PRICE_BASE_ON_PRODUCT_TYPE,
    variant: abtestVariant,
  }
  Analytics.track(
    EVENT_ABTEST_ASSIGNED,
    payload,
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingABTestShowNewOptionProductChristmasTumbler() {
  if (!product.value) return
  if (
    !handlesAbTestShowNewOptionProductChristmasTumbler.includes(
      product.value.handle
    )
  )
    return
  const abtestVariant = getABTestActivedVariantByCode(
    AB_TEST_SHOW_NEW_OPTION_PRODUCT_CHRISTMAS_TUMBLER
  )
  if (abtestVariant === null) return
  const payload = {
    name: AB_TEST_SHOW_NEW_OPTION_PRODUCT_CHRISTMAS_TUMBLER,
    variant: abtestVariant,
  }
  Analytics.track(
    EVENT_ABTEST_ASSIGNED,
    payload,
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingABTestOptionSizePrice() {
  if (
    !product.value ||
    !product.value?.handle?.includes(
      '10692140425scl1tmm1tr04cu03li09hsp1_ipatumcr00002'
    )
  )
    return

  const abtestVariant = getABTestActivedVariantByCode(AB_TEST_OPTION_SIZE_PRICE)
  if (abtestVariant === null) return
  const payload = {
    name: AB_TEST_OPTION_SIZE_PRICE,
    variant: abtestVariant,
  }
  Analytics.track(
    EVENT_ABTEST_ASSIGNED,
    payload,
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function checkShowOptionTypeHtml(optionName?: string) {
  if (!optionName) return false
  const productOption = productOptionsHtml.value.find(
    (productOption: any) =>
      productOption.option.toLowerCase() == optionName.toLowerCase()
  )
  if (!productOption) return false
  const productOptionDataBaseOnProductTag =
    productOption.applyForProductTag.find((item: any) =>
      productStore.product?.tags?.includes(item.productTagRequired)
    )

  if (!productOptionDataBaseOnProductTag) return false
  return true
}

function getProductOptionHtml(
  optionType: string = '',
  optionValue: string = ''
) {
  const productOption = productOptionsHtml.value.find(
    (productOption: any) =>
      productOption.option.toLowerCase() == optionType.toLowerCase()
  )
  if (!productOption) return ''
  const productOptionDataBaseOnProductTag =
    productOption.applyForProductTag.find((item: any) =>
      productStore.product?.tags?.includes(item.productTagRequired)
    )
  if (!productOptionDataBaseOnProductTag) return ''
  const standardOptionValue = optionValue.toLowerCase().replace(/\s/g, '-')
  const option = productOptionDataBaseOnProductTag.keyValue?.find(
    (elm: any) => elm.key == standardOptionValue
  )
  if (!option) return ''
  return option.value
}

function isOptionCustomBadge(optionName: string = '') {
  const badgeSizeCustomize = getBadgeCustomize(optionName)
  return badgeSizeCustomize
}

watch(
  () => product.value?.productType,
  (newType) => {
    if (!isOnServer && newType && !settingStore.baseProductPage?.customBadgeForVariantOptions) {
      settingStore.loadCustomBadgeByProductType(newType)
    }
  },
  { immediate: true }
)

function getBadgeCustomize(optionName: string = '') {
  return settingStore.baseProductPage?.customBadgeForVariantOptions?.badgesCustomize?.find(
    (item) =>
      item.productType?.toLowerCase() ==
        product.value?.productType?.toLowerCase() &&
      optionName.toLowerCase()?.includes(item.productOption?.toLowerCase())
  )
}

function getValueBadge(optionValue: string, optionName: string) {
  const badgeSizeCustomize = getBadgeCustomize(optionName)
  if (!badgeSizeCustomize?.badges?.length) return
  return badgeSizeCustomize.badges.find(
    (item) => item.productOptionValue == optionValue
  )?.html
}

// variant option from option customily logic
function getCustomilyVariantsOptionsElement(optionSortId: string) {
  const customilyOptionWrapper = document.querySelector(
    `.${CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR.replace(
      'option_sort_id',
      optionSortId
    )}`
  )
  if (!customilyOptionWrapper) return
  customilyOptionWrapper.classList.add('hidden')
  const customilyOptionValues = customilyOptionWrapper.querySelectorAll(
    INPUT_CUSTOMILY_SWATCH_SELECTOR
  )
  if (customilyOptionValues?.length) return customilyOptionValues
}
function getCustomilyVariantsOptionValue(customilyOptionVariantsTag: string) {
  const optionSortId = getCustomilySortIdFromTag(customilyOptionVariantsTag)
  const customilyOptionValues = getCustomilyVariantsOptionsElement(optionSortId)
  if (!customilyOptionValues) return
  const valueOptions = []
  for (let i = 0; i < customilyOptionValues?.length; i++) {
    const customilyPropertiesInputValue =
      customilyOptionValues[i].getAttribute('value')
    valueOptions.push(customilyPropertiesInputValue)
    if (customilyOptionValues[i]?.checked) {
      customilyVariantsOptionsActived.value[customilyOptionVariantsTag] =
        customilyPropertiesInputValue
    }
  }
  customilyVariantsOptions.value.push({
    tag: customilyOptionVariantsTag,
    type: customilyVariantsOptionType(customilyOptionVariantsTag),
    name: formatCustomilyVariantsOptionName(customilyOptionVariantsTag),
    options: valueOptions,
  })
}
function getLastCustomilyVariantsOptionValue(
  customilyOptionVariantsTag: string
) {
  const optionSortId = getCustomilySortIdFromTag(customilyOptionVariantsTag)
  const customilyOptionValues = getCustomilyVariantsOptionsElement(optionSortId)
  if (!customilyOptionValues) return
  const valueOptions = []
  for (let i = 0; i < customilyOptionValues?.length; i++) {
    const customilyPropertiesInputValue =
      customilyOptionValues[i].getAttribute('value')
    valueOptions.push(customilyPropertiesInputValue)
    if (customilyOptionValues[i]?.checked) {
      lastCustomilyVariantsOptionsActived.value[customilyOptionVariantsTag] =
        customilyPropertiesInputValue
    }
  }
  lastCustomilyVariantsOptions.value.push({
    tag: customilyOptionVariantsTag,
    type: customilyVariantsOptionType(customilyOptionVariantsTag),
    name: formatCustomilyVariantsOptionName(customilyOptionVariantsTag),
    options: valueOptions,
  })
}
function changeCustomilyVariantsOption(
  customilyOptionVariantsTag: string,
  optionValue: string
) {
  const optionSortId = getCustomilySortIdFromTag(customilyOptionVariantsTag)
  const customilyOptionValues = getCustomilyVariantsOptionsElement(optionSortId)
  if (!customilyOptionValues) return
  for (let i = 0; i < customilyOptionValues?.length; i++) {
    if (customilyOptionValues[i].getAttribute('value') == optionValue)
      customilyOptionValues[i]?.click()
    if (customilyOptionValues[i]?.checked) {
      customilyVariantsOptionsActived.value[customilyOptionVariantsTag] =
        customilyOptionValues[i].getAttribute('value')
    }
  }
}
function changeLastCustomilyVariantsOption(
  customilyOptionVariantsTag: string,
  optionValue: string
) {
  const optionSortId = getCustomilySortIdFromTag(customilyOptionVariantsTag)
  const customilyOptionValues = getCustomilyVariantsOptionsElement(optionSortId)
  if (!customilyOptionValues) return
  for (let i = 0; i < customilyOptionValues?.length; i++) {
    if (customilyOptionValues[i].getAttribute('value') == optionValue)
      customilyOptionValues[i]?.click()
    if (customilyOptionValues[i]?.checked) {
      lastCustomilyVariantsOptionsActived.value[customilyOptionVariantsTag] =
        customilyOptionValues[i].getAttribute('value')
    }
  }
}
function customilyVariantsOptionType(customilyVariantsOptionTag: string) {
  if (isCustomilyColorOption(customilyVariantsOptionTag))
    return OPTION_TYPE_COLOR
  else if (isCustomilySizeOption(customilyVariantsOptionTag))
    return OPTION_TYPE_SIZE
  else return OPTION_TYPE_STYLE
}
function isCustomilySizeOption(customilyVariantsOptionTag: string) {
  return customilyVariantsOptionTag?.toString()?.includes(OPTION_TYPE_SIZE)
}
function isCustomilyColorOption(customilyVariantsOptionTag: string) {
  return customilyVariantsOptionTag?.toString()?.includes(OPTION_TYPE_COLOR)
}
function getCustomilySortIdFromTag(customilyOptionVariantsTag: string) {
  return customilyOptionVariantsTag.split('_').at(-1).split('-').at(-1)
}
function formatCustomilyVariantsOptionName(customilyVariantsOptionTag: string) {
  return (
    customilyVariantsOptionTag
      .split('_')[1]
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ') || customilyVariantsOptionTag
  )
}

function getOptionList(productOption) {
  if (isOptionTypeName(productOption.name)) {
    return filterOptionTypeValues(productOption.values)
  }

  // Hidden color Silver with product Hand Watch
  // if (isOptionColorName(productOption.name)) {
  //   console.log(product, 'product')
  //   const isHandWatch = product?.value?.tags?.includes('Hand Watch')

  //   if (isHandWatch) {
  //     return productOption.values.filter(v => v !== 'Silver')
  //   }

  //   return productOption.values
  // }

  if (isOptionProducedInAndShippedFromName(productOption.name)) {
    return filterOptionProducedInAndShippedFromValues(productOption.values)
  }

  return productOption.values
}

function formatOptionLabel(option: string, productOption: any) {
  const label = removeTrailingPeriod(option)
  if (!isLeverSphereLoopProduct.value || productOption.name !== PACK_OPTIONS) return label
  
  const match = option.match(/\d+/)
  if (match) {
    const count = parseInt(match[0], 10)
    return count === 1 ? '1 PC' : `${count} PCS`
  }
  return label
}

function getPackPricePerPieceHtml(option: string, productOption: any) {
  if (!isLeverSphereLoopProduct.value || productOption.name !== PACK_OPTIONS) return ''
  const match = option.match(/\d+/)
  const count = match ? parseInt(match[0], 10) : 1
  
  const totalPrice = getPriceProductByTypeAndPackOption(
    getSelectedOption(TYPE_OPTIONS),
    getSelectedOption(SIZE_OPTIONS),
    option
  )
  
  if (!totalPrice) return ''
  const perPiecePrice = totalPrice / count
  return `${formatPrice(perPiecePrice)}/pc`
}
</script>

<style lang="scss">
:root {
  --product-option-choice-height: var(--controls-sm-height);
}

#product-shipped-from-popup-content {
  max-width: 700px;
}

.product {
  &__option {
    margin-top: var(--space-medium);

    h2 {
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 4px;

      &.bordered-bottom {
        padding-bottom: 1rem;
      }
    }
  }

  &__size-chart,
  &__small-label {
    font-size: 12px;
    color: var(--color-primary);
    font-weight: normal;
    margin-left: 3em;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  &__small-label {
    margin-left: 0;
    margin-top: 1em;
    display: block;
  }

  &__option-value {
    font-size: 14px;
    font-weight: normal;
  }

  &__option-choices {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em 1em;

    &--small {
      gap: 0.5em 0;
    }

    @include media-lg-up {
      .select {
        width: auto;
      }
    }
  }

  &__option-choice {
    padding: 0 18px;
    display: flex;
    height: var(--product-option-choice-height);
    justify-content: center;
    align-items: center;
    border: solid 1px currentColor;
    border-radius: var(--border-radius-medium);
    font-weight: bold;
    color: var(--text-color-secondary);
    letter-spacing: -0.75px;
    cursor: pointer;
    $optionChoice: &;

    &--actived {
      color: var(--color-primary);
    }

    &--small {
      padding: 0 14px;
      border: none;
      height: calc(var(--product-option-choice-height) - 2px);

      &#{$optionChoice}--actived {
        background-color: var(--background-color);
      }
    }

    &--round {
      --round-option-border-bonus-size: 8px;
      width: var(--product-option-choice-height);
      height: var(--product-option-choice-height);
      border-radius: 50%;
      padding: 0;
      font-size: 0;
      line-height: 0;
      border-color: var(--border-color);
      position: relative;

      &#{$optionChoice}--actived {
        &::after {
          content: ' ';
          display: block;
          position: absolute;
          width: calc(
            var(--product-option-choice-height) +
              var(--round-option-border-bonus-size)
          );
          height: calc(
            var(--product-option-choice-height) +
              var(--round-option-border-bonus-size)
          );
          top: calc(var(--round-option-border-bonus-size) / -2 - 1px);
          left: calc(var(--round-option-border-bonus-size) / -2 - 1px);
          border: solid 2px var(--color-primary);
          border-radius: 50%;
        }
      }
    }

    &--icon {
      --icon-option-size: 48px;
      width: var(--icon-option-size);
      height: var(--icon-option-size);
      padding: 4px;
      border-color: var(--border-color);

      img {
        width: 100%;
      }

      &#{$optionChoice}--actived {
        border: solid 2px var(--color-primary);
      }
    }
  }
}
.product__option-choices-html-actived {
  label {
    border: 1px solid var(--color-primary) !important;
  }
}

.product__option--shipped-from-hidden {
  display: none;
}

.product-option-badge {
  position: absolute;
}
.option-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
}
.option-price-per-piece {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
  font-weight: 500;
}
.product__option-choice--pack-pricing {
  height: 52px !important;
  padding: 6px 12px !important;
  display: inline-flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}
.product__option-extra {
  h2 {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  a {
    text-decoration: none;
  }
}

.product__option_new-choice {
  cursor: pointer;
  border: 1px solid #e6e6e6;
}

.product__option_new-choice-actived {
  cursor: pointer;
  border: 1px solid #000;
}
</style>
